module.exports = __webpack_public_path__ + "img/chery-logo.f3e968e7.png";